import { Action, ActionReducer, ActionReducerMap, combineReducers, createFeatureSelector, createSelector, MetaReducer } from '@ngrx/store';
import * as fromTodo from './todo.reducer';
import * as fromGetBusinesses from './get-businesses.reducer';
import * as fromCreateBusinesses from '../../todos/reducers/create-businesses.reducer';
import * as fromSelectedLegalEntity from './selected-legal-entity.reducer';
import * as fromToolbarNotifications from './toolbar-notifications.reducer';
import * as fromRegulationVerified from './regulation-verified.reducer';

export const todoFeatureKey = 'todo';

export interface ToDoMainState {
  [fromTodo.todoFeatureKey]: fromTodo.ToDoListState;
  [fromGetBusinesses.getBusinessesFeatureKey]: fromGetBusinesses.GetBusinessesState;
  [fromCreateBusinesses.createBusinessesFeatureKey]: fromCreateBusinesses.CreateBusinessesState;
  [fromSelectedLegalEntity.selectedLegalEntityFeatureKey]: fromSelectedLegalEntity.SelectedLegalEntityState;
  [fromToolbarNotifications.toolbarNotificationsFeatureKey]: fromToolbarNotifications.ToolbarNotificationsState;
  [fromRegulationVerified.regulationVerifiedFeatureKey]: fromRegulationVerified.RegulationVerifiedState;
}

export interface State {
  [todoFeatureKey]: ToDoMainState;
}

export function reducers(state: ToDoMainState | undefined, action: Action) {
  return combineReducers({
    [fromTodo.todoFeatureKey]: fromTodo.reducer,
    [fromGetBusinesses.getBusinessesFeatureKey]: fromGetBusinesses.reducer,
    [fromCreateBusinesses.createBusinessesFeatureKey]: fromCreateBusinesses.reducer,
    [fromSelectedLegalEntity.selectedLegalEntityFeatureKey]: fromSelectedLegalEntity.reducer,
    [fromToolbarNotifications.toolbarNotificationsFeatureKey]: fromToolbarNotifications.reducer,
    [fromRegulationVerified.regulationVerifiedFeatureKey]: fromRegulationVerified.reducer
  })(state, action);
}

export const selectRootToDoState = createFeatureSelector<State, ToDoMainState>(todoFeatureKey);

export const getLegalEntitiesBusinessesState = createSelector(
  selectRootToDoState,
  state => state[fromGetBusinesses.getBusinessesFeatureKey]
);

export const getLegalEntitiesCreatedBusinessState = createSelector(
  selectRootToDoState,
  state => state[fromCreateBusinesses.createBusinessesFeatureKey]
);

export const getSelectedLegalEntityState = createSelector(
  selectRootToDoState,
  state => state[fromSelectedLegalEntity.selectedLegalEntityFeatureKey]
);

export const getToolbarNotificationsState = createSelector(
  selectRootToDoState,
  state => state[fromToolbarNotifications.toolbarNotificationsFeatureKey]
);

export const getRegulationVerifiedState = createSelector(
  selectRootToDoState,
  state => state[fromRegulationVerified.regulationVerifiedFeatureKey]
);
